module.exports = __webpack_public_path__ + "img/20200514_153336.2d66ad41.jpg";